// extracted by mini-css-extract-plugin
var _1 = "_goldTransactionForm-module__available-balance";
var _2 = "_goldTransactionForm-module__button-container";
var _3 = "_goldTransactionForm-module__button-subcontainer";
var _4 = "_goldTransactionForm-module__close-button";
var _5 = "_goldTransactionForm-module__close-button-container";
var _6 = "_goldTransactionForm-module__container";
var _7 = "_goldTransactionForm-module__container-justify-end";
var _8 = "_goldTransactionForm-module__filter-container";
var _9 = "_goldTransactionForm-module__form-container";
var _a = "_goldTransactionForm-module__full-width";
var _b = "_goldTransactionForm-module__joint-account-details-container";
var _c = "_goldTransactionForm-module__products-container";
var _d = "_goldTransactionForm-module__remarks-text";
var _e = "_goldTransactionForm-module__span-2";
export { _1 as "available-balance", _2 as "button-container", _3 as "button-subcontainer", _4 as "close-button", _5 as "close-button-container", _6 as "container", _7 as "container-justify-end", _8 as "filter-container", _9 as "form-container", _a as "full-width", _b as "joint-account-details-container", _c as "products-container", _d as "remarks-text", _e as "span-2" }
